document.addEventListener("DOMContentLoaded", () => {

    let verifyAgeCookie = getLocationCookie('verify-age');
	if( !verifyAgeCookie ) {
        console.log(verifyAgeCookie);
		const element = document.querySelector(".openVerifyAgeModal");
        if (element) {
            console.log('element exit');
            element.click();
        }
	}

    function handleVerifyAgeButtonClick() {
        var closeVerifyAgeModalButton =  document.querySelector('.close-verify_age-modal');
        var date = new Date();
    	date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
		var expires = "; expires=" + date.toUTCString();
		document.cookie = "verify-age=yes;path=/;"+ expires;
        closeVerifyAgeModalButton.click();
    }

    const verifyAgeButton = document.querySelector('.verify-age-confirm-button');

    // 3. Attach the click event listener to the button
    verifyAgeButton.addEventListener('click', handleVerifyAgeButtonClick);
    
    function getLocationCookie(cname) {
    	var name = cname + '=';
    	var decodedCookie = decodeURIComponent(document.cookie);
        //console.log(decodedCookie);
    	var ca = decodedCookie.split(';');
    	for (var i = 0; i < ca.length; i++) {
    		var c = ca[i];
    		while (c.charAt(0) === ' ') {
    			c = c.substring(1);
    		}
    		if (c.indexOf(name) === 0) {
    			return c.substring(name.length, c.length);
    		}
    	}
    	return '';
    }
});